import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SlideView from "@/views/share/SlideView.vue";
import {onMounted, onUnmounted} from "vue";
import {useRoute} from "vue-router";
import emit from "@/lib/emit";
import {AEditor} from "@/views/editor/service/editor";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorSide',
  setup(__props) {


const editor = useRoute().meta.editor as AEditor;

onMounted(() => {
  emit.on('window.resize', windowSizeChange)
  windowSizeChange();
})

onUnmounted(() => {
  emit.off('window.resize', windowSizeChange)
})

const windowSizeChange = () => {
  if (window.innerWidth < 1600 && !editor.active.menu.toggle) editor.active.menu.toggle = true;
  else if (window.innerWidth > 1600 && editor.active.menu.toggle) editor.active.menu.toggle = false;
}


return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(SlideView, {
    toggle: _unref(editor).active.menu.toggle,
    "onUpdate:toggle": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editor).active.menu.toggle) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_menu, {
        items: _unref(editor).active.menu.items,
        "inline-collapsed": _unref(editor).active.menu.toggle,
        "open-keys": _unref(editor).active.menu.openKeys,
        "selected-keys": _unref(editor).active.menu.selectedKeys,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editor).active.menu.selectedKeys) = $event)),
        mode: "inline",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor).onMenuClick($event)))
      }, null, 8, ["items", "inline-collapsed", "open-keys", "selected-keys"])
    ]),
    _: 1
  }, 8, ["toggle"]))
}
}

})